import {
  MdSignalCellularConnectedNoInternet0Bar,
  MdSignalCellular1Bar,
  MdSignalCellular3Bar,
  MdSignalCellular4Bar,
} from "react-icons/md";
import { ImCancelCircle } from "react-icons/im";
import { AiFillWarning } from "react-icons/ai";
import { FaCheckCircle } from "react-icons/fa";
import styles from "./deviceTable.module.scss";

export const titleCase = (str: string): string => {
  if (typeof str !== "string") return "";
  // 將 str 傳過來的字串 做js格式化： 取得 第一個字 轉為 大寫 + 第二個字開始後面的小寫  假設 str = "critical"
  // let newStr = str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();  結果為 Critical
  let newStr = str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
  //Health Status: QA suggest Up -> Good
  if (newStr === "Up") {
    newStr = "Good";
  }
  if (newStr === "Na" || newStr === "na") {
    newStr = "NA";
  }
  return newStr;
};

export const healthIcon = (health: string) => {
  switch (health) {
    case "up":
      return <FaCheckCircle className={styles.up} />;
    case "critical":
      return <AiFillWarning className={styles.critical} />;
    case "warning":
      return <AiFillWarning className={styles.warning} />;
    case "offline":
      return <ImCancelCircle className={styles.offline} />;
    default:
      return;
  }
};
export const strengthIcon = (strength: string) => {
  switch (strength) {
    case "excellent":
      return <MdSignalCellular4Bar className={styles.up} />;
    case "good":
      return <MdSignalCellular3Bar className={styles.warning} />;
    case "fair":
      return <MdSignalCellular1Bar className={styles.critical} />;
    case "poor":
      return <MdSignalCellularConnectedNoInternet0Bar className={styles.offline} />;
    default:
      return;
  }
};
